import { render, staticRenderFns } from "./tappay-page.vue?vue&type=template&id=baae4852&"
import script from "./tappay-page.vue?vue&type=script&lang=js&"
export * from "./tappay-page.vue?vue&type=script&lang=js&"
import style0 from "./tappay-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tappay-page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports